import Image from '@/components/Image'
import { PromotionalTag } from '@/components/PromotionalTag'
import { IPromotionalTag } from '@/types/cms'
import cn from '@/utils/cn'

type TProps = {
  release?: boolean
  badges: string[]
  machineImageName: {
    left: string
    front: string
    right: string
  }
  machinePopularName: string
  discountPercent: string
  promotionalTag: IPromotionalTag
}

const DefaultProducts = ({
  badges,
  machineImageName,
  discountPercent,
  machinePopularName,
  promotionalTag
}: TProps) => {
  return (
    <>
      <div className="absolute top-[-60px] sm:top-[-50px] left-0 max-w-[141px] sm:max-w-[172px]">
        <Image
          src={`ton-cms/prd/${machineImageName.left}.webp`}
          alt={`Imagem da maquininha ${machinePopularName}`}
          width={130}
          height={195}
          className="object-cover max-w-full h-auto"
        />

        {promotionalTag && (
          <PromotionalTag
            className="absolute top-0 left-[90px] w-[145px] h-[83px]"
            value={discountPercent}
            variant={promotionalTag.variant}
          />
        )}
      </div>

      <div className="flex justify-end ml-auto">
        {badges?.map((badge, index) => (
          <div
            className={cn(
              'ml-[-18px] first:z-40',
              badges?.length > 1 &&
                'max-w-[88px] max-h-[88px] md:max-w-[88px] md:max-h-[88px]'
            )}
            key={`img-name-${badge}-${index}`}
          >
            <Image
              src={`site-ton/${badge}1.png`}
              alt={`Icone representando a feature ${badge}`}
              width={96}
              height={96}
              className="object-cover max-w-full h-auto rounded-full"
            />
          </div>
        ))}
      </div>
    </>
  )
}

export default DefaultProducts
